import { get } from 'lodash';

export default {
  firstTimeLogin({ commit, getters }) {
    const { sites } = getters;
    const firstSite = get(sites, '[0].id');
    commit('setActiveSite', firstSite);
  },
};
